import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import * as settings from '../common/settings';
import * as enums from '../common/enums';
import * as aspObjects from '../asp/aspObjects';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { aspMngr } from '../asp/AspMngr';
import { AspObject, ObjectType } from './../asp/AspObject';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as utils from '../common/utils';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AroSensorTabDetailsComponent } from 'src/app/aro/aro-sensor-tab-details.component';
import { Animations } from '@core_n/Animations';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';
import { dialogType } from '@core_n/enums';

//
// Status Bar
//
@Component({
  selector: 'sensor-window',
  templateUrl: './sensor-window.component.html',
  styleUrls: ['./sensor-window.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class SensorWindowComponent extends ZIndexMngr implements OnInit, AfterViewInit {
  public Sensors: Map<any, AspObject>;
  public sensorsToArray: Array<AspObject>;
  public FilteredSensors: any[] = [];
  public SearchResults: string;

  constructor(
    public dialogRef: MatDialogRef<SensorWindowComponent>, 
    elementRef: ElementRef, 
    private dialog: MatDialog) {

    super(elementRef);
    this.Sensors = aspMngr.getObjectsPool(ObjectType.Sensor).getAllObjects();
    this.sensorsToArray = Array.from(this.Sensors.values());
    this.FilteredSensors = this.sensorsToArray.filter(sensor =>
      'isRadar' in sensor && 'isAcoustic' in sensor && 'isVideo' in sensor)
      .map(sensor => sensor as SensorCoreObject);
      this.windowVisible.next(true);
      
   /* this.FilteredSensors.forEach(element => {
      console.log(`Radar: ${element.isRadar}, Acoustic: ${element.isAcoustic}`)
    });*/
    
    settings.userSettings.poolChanged.subscribe(x => {
      this.onSearchChange();
    });
  }

  static createDialogConfig(top: number, left: number) {
    return utils.createDialogConfig(false, false, dialogType.SensorWindow,
      { top: `${top + 10}px`, left: `${left + 10}px` });
  }

  ngOnInit() {
    this.windowVisible.next(true);
    this.windowClick();   
  }

  ngAfterViewInit() {
   /* setTimeout(() => {
      this.windowVisible.next(true);
    })*/
  }

  onSearchChange() {
    if (this.SearchResults == undefined || this.SearchResults == '' || this.SearchResults == null) {
      this.FilteredSensors = Array.from(this.Sensors.values());
      return;
    }
    this.SearchResults = this.SearchResults.toLowerCase();
    this.FilteredSensors = [];
    this.Sensors.forEach(sns => {
      let added = false;
      let identifiers = sns.getIdentifiers();
      identifiers.forEach(str => {
        if(str.includes(this.SearchResults) && !added){
          this.FilteredSensors.push(sns);
          added = true;
        }
      })
    });
  }

  sensorWindowClicked() {
    this.dialog.open(AroSensorTabDetailsComponent, AroSensorTabDetailsComponent.createDialogConfig(100));
  }
}
